import container from './container.js';
import titleBar from './title-bar.js';

export default {
    container,
    titleBar
};
